// Third Party
import React from 'react';

// Types
import ProposalToolbarOption from '@/types/proposal-toolbar-option';
import LocalizedString from '@/types/localized-string';
import Locale from '@/types/locale';

// Utils
import { formatAccessibilityDescription } from '@/utils/accessibility-description';

type Props = {
  description: LocalizedString;
  items?: string[];
  locale?: Locale;
  toolbarOption?: ProposalToolbarOption;
};

const AccessibilityDescription = ({ description, locale, items, toolbarOption }: Props) => (
  <div className="visually-hidden">
    {formatAccessibilityDescription(
      description,
      locale,
      items,
      toolbarOption?.startDate,
      toolbarOption?.endDate,
      toolbarOption?.capital,
      toolbarOption?.periodLabel,
    )}
  </div>
);

export default AccessibilityDescription;
